import { useResponsive } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

/**
 * Returns whether the upsell screen should be shown based on feature flag and screen size.
 */
export const useShouldShowUpsellScreen = () => {
  const { minWidth } = useResponsive();
  const isUpsellScreenEnabled =
    useFeatureFlag('CELS-4432-upsell-modal-order') && minWidth.isSM;

  return isUpsellScreenEnabled;
};
